import React from 'react';
import { Card, CardContent } from '../ui/Card';
import SafeIcon from '../../common/SafeIcon';
import ReactECharts from 'echarts-for-react';

export const ScoreGauge = ({ title, value, color = '#6366f1', size = 'sm' }) => {
  const option = {
    series: [{
      type: 'gauge',
      startAngle: 210,
      endAngle: -30,
      min: 0,
      max: 100,
      radius: '100%',
      axisLine: { lineStyle: { width: 4, color: [[value / 100, color], [1, '#f1f5f9']] } },
      pointer: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { 
        fontSize: size === 'sm' ? 16 : 24, 
        fontWeight: '900', 
        offsetCenter: [0, 0], 
        formatter: '{value}%', 
        color: '#1e293b' 
      },
      data: [{ value }]
    }]
  };

  return (
    <Card className="border-none shadow-sm">
      <CardContent className="p-4 text-center">
        <div className={size === 'sm' ? "h-20" : "h-32"}>
          <ReactECharts option={option} style={{ height: '100%' }} />
        </div>
        <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mt-1 truncate">{title}</p>
      </CardContent>
    </Card>
  );
};

export const ActionItem = ({ title, desc, icon, onClick }) => (
  <div onClick={onClick} className="flex gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100 hover:bg-white hover:shadow-md transition-all cursor-pointer group">
    <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-indigo-600 shadow-sm group-hover:bg-indigo-600 group-hover:text-white transition-all">
      <SafeIcon name={icon} />
    </div>
    <div>
      <h4 className="text-sm font-bold text-slate-900">{title}</h4>
      <p className="text-xs text-slate-500">{desc}</p>
    </div>
  </div>
);